import { FormEvent, useState } from "react";
import { GameLobbyMode, User } from "./types";
import {
  BET_STRATEGIES,
  DEFAULT_BET_STRATEGY,
  DEFAULT_MODE,
  DEFAULT_OPERATOR_ID,
  DEFAULT_VARIANT,
  gameId,
  hasBetStructure,
  isVariant,
  MODES,
  Variant,
  VARIANTS,
} from "./poker-client-launch";

export const LoginForm = (props: { setUser: (user: User) => void }) => {
  const [advanced, setAdvanced] = useState(false);
  const [username, setUsername] = useState("");
  const [operatorId, setOperatorId] = useState(String(DEFAULT_OPERATOR_ID));
  const [featureFlags, setFeatureFlags] = useState("");
  const [openAsIframe, setOpenAsIframe] = useState(false);
  const [gameLobby, setGameLobby] = useState(false);
  const [betStrategy, setBetStrategy] = useState<string>(DEFAULT_BET_STRATEGY);
  const [variant, setVariant] = useState<Variant>(DEFAULT_VARIANT);
  const [mode, setMode] = useState<GameLobbyMode>(DEFAULT_MODE);

  // The lobby options only mean anything when the game lobby is the entry, so
  // leave them off the launch config entirely otherwise.
  const lobbyOptions = () =>
    gameLobby
      ? { gameLobby: true, gameId: gameId(betStrategy, variant, mode) }
      : {};

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (username.length > 0) {
      console.log("Valid username ", username);
      // You can use openAsWebComponent here as needed
      props.setUser({
        name: username,
        operatorId: parseInt(operatorId),
        loggedIn: true,
        webComponent: !openAsIframe,
        featureFlags: featureFlags.trim() || undefined,
        ...lobbyOptions(),
      });
    }
  };
  return (
    <div className={"form-container"}>
      <form className={"login-form"} onSubmit={onSubmit}>
        <div className={"advanced-container"}>
          {!advanced && (
            <div onClick={() => setAdvanced(true)}>
              &nbsp;{/*<i className="bi bi-gear-fill"></i>*/}
            </div>
          )}
          {advanced && (
            <div onClick={() => setAdvanced(false)}>
              <i className="bi bi-x-octagon-fill"></i>
            </div>
          )}
        </div>
        <div className="mb-4">
          <label htmlFor="username" className="form-label">
            Username
          </label>
          <input
            name={"username"}
            className={"form-control"}
            type={"text"}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <div id="usernameHelp" className="form-text mb-4">
            Enter any username to log in to Cubeia's Demo Poker Platform!
          </div>
          {advanced && (
            <div>
              <label htmlFor="operatorId" className="form-label">
                Poker Operator Id
              </label>
              <input
                name={"operatorId"}
                className={"form-control mb-4"}
                type={"text"}
                value={operatorId}
                onChange={(e) => setOperatorId(e.target.value)}
              />
              <label htmlFor="featureFlags" className="form-label">
                Feature Flags
              </label>
              <input
                name={"featureFlags"}
                className={"form-control mb-4"}
                type={"text"}
                value={featureFlags}
                onChange={(e) => setFeatureFlags(e.target.value)}
              />
              <div className="mb-4">
                <input
                  className="form-check-input"
                  style={{ marginRight: "8px" }}
                  type="checkbox"
                  id="gameLobby"
                  checked={gameLobby}
                  onChange={(e) => setGameLobby(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="gameLobby">
                  Game lobby
                </label>
              </div>
              {gameLobby && (
                <div>
                  {hasBetStructure(variant) && (
                    <>
                      <label htmlFor="betStrategy" className="form-label">
                        Bet Structure
                      </label>
                      <select
                        id="betStrategy"
                        name={"betStrategy"}
                        className={"form-select mb-4"}
                        value={betStrategy}
                        onChange={(e) => setBetStrategy(e.target.value)}
                      >
                        {BET_STRATEGIES.map((value) => (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        ))}
                      </select>
                    </>
                  )}
                  <label htmlFor="variant" className="form-label">
                    Variant
                  </label>
                  <select
                    id="variant"
                    name={"variant"}
                    className={"form-select mb-4"}
                    value={variant}
                    onChange={(e) => {
                      if (isVariant(e.target.value)) setVariant(e.target.value);
                    }}
                  >
                    {VARIANTS.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="mode" className="form-label">
                    Mode
                  </label>
                  <select
                    id="mode"
                    name={"mode"}
                    className={"form-select mb-4"}
                    value={mode}
                    onChange={(e) => setMode(e.target.value as GameLobbyMode)}
                  >
                    {MODES.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="mb-4">
                <input
                  className="form-check-input"
                  style={{ marginRight: "8px" }}
                  type="checkbox"
                  id="openAsIframe"
                  checked={openAsIframe}
                  onChange={(e) => setOpenAsIframe(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="openAsIframe">
                  Open in iframe
                </label>
              </div>
            </div>
          )}
        </div>

        <button className={"btn btn-primary mb-2"} type={"submit"}>
          Play
        </button>
      </form>
    </div>
  );
};
